import Smartphones from 'Documents/views/DocumentView/containers/Smartphones'
import Tablets from 'Documents/views/DocumentView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const DocumentView = getCurrentDeviceView(Smartphones, Tablets)

export default DocumentView
